import { useTranslation } from 'react-i18next'
import { SafetyOutlined, LockOutlined, CheckCircleOutlined, GlobalOutlined } from '@ant-design/icons'
import './GlassFooter.css'

const GlassFooter = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="professional-footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-section">
            <h3 className="footer-heading">{t('brand.name', 'WhistlePro')}</h3>
            <p className="footer-description">
              {t('footer.description', 'Enterprise-grade whistleblowing platform ensuring complete anonymity and regulatory compliance.')}
            </p>
            <div className="footer-certifications">
              <div className="cert-badge">
                <SafetyOutlined /> {t('footer.certifications.iso', 'ISO 27001')}
              </div>
              <div className="cert-badge">
                <CheckCircleOutlined /> {t('footer.certifications.soc', 'SOC 2')}
              </div>
            </div>
          </div>
        
          <div className="footer-section">
            <h4 className="footer-section-title">{t('footer.sections.platform', 'Platform')}</h4>
            <ul className="footer-links">
              <li><a href="/pricing" className="footer-link">{t('footer.links.pricing', 'Pricing Plans')}</a></li>
              <li><a href="/lookup" className="footer-link">{t('footer.links.trackCase', 'Track Case')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.howItWorks', 'How It Works')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.security', 'Security')}</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-section-title">{t('footer.sections.legal', 'Legal')}</h4>
            <ul className="footer-links">
              <li><a href="/privacy" className="footer-link">{t('footer.links.privacy', 'Privacy Policy')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.terms', 'Terms of Service')}</a></li>
              <li><a href="/cookies" className="footer-link">{t('footer.links.cookies', 'Cookie Policy')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.gdpr', 'GDPR Rights')}</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-section-title">{t('footer.sections.resources', 'Resources')}</h4>
            <ul className="footer-links">
              <li><a href="#" className="footer-link">{t('footer.links.documentation', 'Documentation')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.api', 'API Reference')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.support', 'Support Center')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.links.contact', 'Contact Sales')}</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              {t('footer.copyright', { year: currentYear, defaultValue: `© ${currentYear} WhistlePro. All rights reserved.` })}
            </div>
            
            <div className="footer-compliance">
              <div className="compliance-item">
                <LockOutlined /> {t('footer.compliance.ssl', 'SSL/TLS Encrypted')}
              </div>
              <div className="compliance-item">
                <GlobalOutlined /> {t('footer.compliance.euDirective', 'EU Directive 2019/1937')}
              </div>
              <div className="compliance-item">
                <CheckCircleOutlined /> {t('footer.compliance.gdpr', 'GDPR Compliant')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default GlassFooter